module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "map-area section-padding section product_section_new",
    staticStyle: {
      "height": "900px"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("产品中心")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_vm._v("PRODUCTS")]), _vm._v(" "), _c('P', {
    staticClass: "p3 animate fadeInUp animated jjfangan_zt4",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "visibility": "visible"
    }
  }, [_c('div', {
    staticClass: "chanpin"
  }, [_vm._v("\n          拿度磁致伸缩位移/液位传感器,DIMETIX激光测距传感器具有绝对位移测量、精度高、永不磨损、坚固耐用、运行可靠、耐严苛环境等优点，广泛应用于液压伺服、冶金制造，工控机械、石化、水利、灌装、风电光伏等。")])])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "jobs-area section-padding2"
  }, [_c('div', {
    staticClass: "product_sun_tab"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sun_tab_fu"
  }, [_c('div', {
    staticClass: "sun_tab_fu1"
  }, [_c('div', {
    staticClass: "sun_tab_fu2 animate fadeInLeft animated",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.1s"
    }
  }, _vm._l((_vm.chanpintab.son), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "suntab_xun",
      on: {
        "mouseover": function($event) {
          return _vm.handleMouseOver(item.scode)
        },
        "mouseleave": function($event) {
          return _vm.handleMouseLeave(item.scode)
        }
      }
    }, [(item.scode == _vm.itemscode) ? _c('div', {
      staticClass: "sun_xuna xuanzhong"
    }) : _c('div', {
      staticClass: "sun_xuna"
    }), _vm._v(" "), (item.scode == _vm.itemscode) ? _c('div', {
      staticClass: "sun_xunb"
    }, [(item.scode == _vm.scodein) ? _c('p', {
      staticStyle: {
        "font-weight": "600",
        "color": "#4bbfbc"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('p', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "buxianshichanpin",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.subname))])]) : _c('div', {
      staticClass: "sun_xunb"
    }, [_c('p', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "buxianshichanpin",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.subname))])]), _vm._v(" "), (item.scode == _vm.itemscode) ? _c('div', {
      staticClass: "sun_xunc xuanzhonga"
    }) : _c('div', {
      staticClass: "sun_xunc"
    })])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "chanpin_s1"
  }, _vm._l((_vm.pubiclist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chanpin_s1_01 animate zoomIn animated",
      staticStyle: {
        "animation-duration": "0.6s",
        "animation-delay": "0.1s"
      }
    }, [_c('a', {
      attrs: {
        "href": '/chanpin?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "chanpin_s101_a"
    }, [_c('div', {
      staticClass: "chanpin_s101_a1"
    }, [_c('img', {
      staticStyle: {
        "height": "auto"
      },
      attrs: {
        "src": _vm.newurl + item.ico
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "chanpin_s101_a2"
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yingyongfenlei zengjiaxin"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "position": "relative"
    }
  }, [_vm._v("右滑查看更多分类->")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3795690b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JobCategory.vue
// module id = 103
// module chunks = 0